import React from 'react';
import { Link } from 'react-router-dom';
export const SEOTextSection = () => {
  return <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-492">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-493">
        <div className="prose prose-invert max-w-none" data-id="element-494">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-495">
            Bij <span className="text-[#D6281F]" data-id="element-496">BKCustoms</span> brengen wij
            jouw auto naar een hoger niveau
          </h2>
          <p className="text-white/80 mb-4" data-id="element-497">
            Met jarenlange ervaring in <strong data-id="element-498">autostyling in Almere</strong> en
            een passie voor perfectie, biedt BKCustoms hoogwaardige diensten
            aan, waaronder{' '}
            <Link to="/diensten/autowrappen" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-499">
              autowrapping
            </Link>
            ,{' '}
            <Link to="/diensten/ramen-tinting" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-500">
              raam tinten
            </Link>
            ,{' '}
            <Link to="/diensten/lichten-smoken" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-501">
              lichten tinten
            </Link>
            , en{' '}
            <Link to="/diensten/ontchromen" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-502">
              ontchromen
            </Link>
            . Wij combineren vakmanschap, de beste materialen, en een
            persoonlijke aanpak om jouw voertuig te transformeren tot een waar
            kunstwerk op wielen.
          </p>
          <p className="text-white/80 mb-8" data-id="element-503">
            Of je nu een volledig nieuwe look wilt voor je auto of juist
            subtiele aanpassingen zoals{' '}
            <Link to="/diensten/alloygator" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-504">
              bescherming voor je velgen
            </Link>
            , BKCustoms levert altijd maatwerk met oog voor elk detail. Onze
            gespecialiseerde autostyling diensten in Almere zijn ontworpen om te
            voldoen aan de hoogste eisen, zodat jouw auto een unieke uitstraling
            krijgt.
          </p>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-505">
            Waarom kiezen voor <span className="text-[#D6281F]" data-id="element-506">BKCustoms</span>{' '}
            in Almere?
          </h3>
          <p className="text-white/80 mb-8" data-id="element-507">
            BKCustoms onderscheidt zich door zijn toewijding aan vakmanschap en
            kwaliteit. Ons team van ervaren professionals werkt met de nieuwste
            technieken en de beste materialen om jouw voertuig perfect af te
            leveren. Met ons{' '}
            <Link to="/diensten/maatwerk-advies" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-508">
              maatwerk
            </Link>{' '}
            transformeren we elke auto naar jouw exacte wensen. Klanten in
            Almere en omgeving waarderen onze persoonlijke service en ons
            vermogen om aan de hoogste verwachtingen te voldoen.
          </p>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-509">
            Over <span className="text-[#D6281F]" data-id="element-510">Ons</span>
          </h3>
          <p className="text-white/80 mb-4" data-id="element-511">
            BKCustoms is meer dan alleen een autostylingbedrijf in Almere – wij
            zijn jouw partner in het realiseren van een unieke en exclusieve
            look voor je voertuig. Ons toegewijde team combineert ervaring met
            passie, wat resulteert in niets minder dan perfectie. Elk project,
            van een complete{' '}
            <Link to="/diensten/autowrappen" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-512">
              autowrap
            </Link>{' '}
            tot kleine verfijningen, wordt met de grootste zorg uitgevoerd.
          </p>
          <p className="text-white/80 mb-8" data-id="element-513">
            <Link to="/over-ons" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-514">
              Lees verder over hoe BKCustoms jouw visie tot leven kan brengen
            </Link>{' '}
            en ontdek meer over ons vakmanschap en onze aanpak in Almere.
          </p>
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-center" data-id="element-515">
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-516">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-517">
              Auto Wrappen Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-518">
              Premium car wrapping met hoogwaardige folies voor een unieke look.
            </p>
            <Link to="/diensten/autowrappen" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-519">
              Meer informatie →
            </Link>
          </div>
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-520">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-521">
              Ramen Tinten Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-522">
              Privacy en UV-bescherming met stijlvolle raamfolie.
            </p>
            <Link to="/diensten/ramen-tinting" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-523">
              Meer informatie →
            </Link>
          </div>
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-524">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-525">
              Lichten Smoken Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-526">
              Stijlvolle getinte lichten voor een krachtige uitstraling.
            </p>
            <Link to="/diensten/lichten-smoken" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-527">
              Meer informatie →
            </Link>
          </div>
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-528">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-529">
              Ontchromen Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-530">
              Chrome delete voor een moderne, strakke look.
            </p>
            <Link to="/diensten/ontchromen" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-531">
              Meer informatie →
            </Link>
          </div>
        </div>
      </div>
    </section>;
};